import classNames from 'classnames'
import React, { AnchorHTMLAttributes, HTMLAttributes, ReactNode } from 'react'
import { Link, LinkProps } from 'react-router-dom'

export interface DropdownMenuItemProps extends HTMLAttributes<HTMLLIElement> {
  children: ReactNode
  className?: string
  aProps?: AnchorHTMLAttributes<HTMLAnchorElement>
  linkProps?: LinkProps
  isActive?: boolean
}

export default function DropdownMenuItem(props: DropdownMenuItemProps): JSX.Element {
  const { children, className, aProps, linkProps, isActive, ...otherProps } = props
  const mergedClassName = classNames('dropdown-menu__item', className, {
    'dropdown-menu__item--active': isActive,
    'dropdown-menu__item--link': !!linkProps || !!aProps
  })
  function renderChildren() {
    if (aProps) {
      return <a {...aProps}>{children}</a>
    }
    if (linkProps) {
      return <Link {...linkProps}>{children}</Link>
    }

    return children
  }

  return (
    <li className={mergedClassName} {...otherProps}>
      {renderChildren()}
    </li>
  )
}
